import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'column'
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    margin: theme.spacing(0.5)
  },
  divider: {
    width: 1,
    height: 24,
    backgroundColor: theme.colorPalette.beige_60
  },
  container: {
    borderRadius: theme.sizes.roundCorners,
    border: `2px solid ${theme.colorPalette.white}`,
    padding: theme.spacing(6, 8),
    marginBottom: theme.spacing(2),
    width: '100%',
    flexGrow: 1
  },
  smallButton: {
    width: 64
  },
  section: {
    width: '100%'
  },
  riskCard: {
    background: theme.colorPalette.beige_40,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8)
  },
  coverageCard: {
    background: theme.colorPalette.green_90,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8),
    borderBottomLeftRadius: theme.sizes.roundCorners,
    borderBottomRightRadius: theme.sizes.roundCorners
  },
  rceLabel: {
    gap: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    whiteSpace: 'nowrap'
  },
  rceValues: {
    gap: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    whiteSpace: 'nowrap'
  },
  bottomMargin: {
    marginBottom: theme.spacing(2)
  },
  sectionDivider: {
    borderTop: `1px solid ${theme.colorPalette.beige_25_op_30}`,
    paddingTop: theme.spacing(4)
  },
  notification: {
    minHeight: 30,
    boxShadow: 'none'
  },
  rentersInfoTextContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    '& svg': {
      marginRight: theme.spacing(2)
    }
  },
  rentersInfoText: {
    fontSize: '12px',
    color: theme.colorPalette.green_100
  },
  openSidesCheckbox: {
    minHeight: '66px !important'
  },
  editIcon: {
    width: 22,
    height: 22
  },
  editButton: {
    padding: 0
  },
  description: {
    marginTop: theme.spacing(-2)
  },
  coverageToggleContainer: {
    width: '100%',
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.colorPalette.green_80}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4, 8)
  },
  exclusionToggleContainer: {
    width: '100%',
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.colorPalette.green_80}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4)
  },
  link: {
    color: theme.colorPalette.orange_50,
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px'
  },
  linkAndIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  adjustCoverageSubContainer: {
    borderTop: `1px solid ${theme.colorPalette.green_80}`,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.colorPalette.white
  },
  radio: {
    fonteSize: 14
  },
  // #35617: shown next to a locked Coverage A/E limit for a non-authority user.
  coverageLimitLockWarning: {
    marginTop: theme.spacing(2),
    color: theme.colors.error
  },
  loaderContainer: {
    marginTop: 32,
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 32
  },
  loader: {
    color: theme.palette.secondary.main
  }
}));

export default useStyles;
